<template>
  <div class="close-button rounded-full" :class="category">
    <svg version="1.1" id="close-svg" xmlns="http://www.w3.org/2000/svg"
         xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         width="48px" height="48px" viewBox="0 0 48 48" enable-background="new 0 0 48 48" xml:space="preserve">
            <g>
              <circle fill="#ED562F" cx="24" cy="24.002" r="24"/>
              <polygon fill="#FFFFFF" points="38.552,14.104 33.9,9.451 24,19.353 14.098,9.451 9.447,14.1 19.35,24.003 9.449,33.904
                14.1,38.553 24,28.654 33.896,38.553 38.548,33.9 28.65,24.004 	"/>
            </g>
          </svg>
  </div>
</template>

<script>
  export default {
    name: "CloseOverlayButton",
    props: ['category']
  }
</script>

<style lang="scss" scoped>

  .close-button {
    width: 48px;
    height: 48px;

    svg {
      circle {
        transition: fill .25s ease;
      }

      &:hover {
        cursor: pointer;
      }
    }

    &.basketball {

      &:hover {
        circle {
          fill: config('colors.c3-f2');
        }
      }

      svg {
        circle {
          fill: config('colors.c1-b');
        }
      }
    }

    &.football {

      &:hover {
        circle {
          fill: config('colors.c1-f2');
        }
      }

      svg {
        circle {
          fill: config('colors.c2-b')
        }
      }
    }

    &.baseball {

      &:hover {
        circle {
          fill: config('colors.c4-f2');
        }
      }

      svg {
        circle {
          fill: config('colors.c3-b');
        }
      }
    }

    &.soccer {

      &:hover {
        circle {
          fill: config('colors.c5-f2');
        }
      }

      svg {
        circle {
          fill: config('colors.c4-b');
        }
      }
    }

    &.more-sports {

      &:hover {
        circle {
          fill: config('colors.c2-f2');
        }
      }

      svg {
        circle {
          fill: config('colors.c5-b');
        }
      }
    }

    &.olympics {

      &:hover {
        circle {
          fill: config('colors.c6-f2');
        }
      }

      svg {
        circle {
          fill: config('colors.c6-f1');
        }
      }
    }

    &.hockey {

      &:hover {
        circle {
          fill: config('colors.c7-f2');
        }
      }

      svg {
        circle {
          fill: config('colors.c7-f1');
        }
      }
    }

    &.tennis {

      &:hover {
        circle {
          fill: config('colors.c8-f2');
        }
      }

      svg {
        circle {
          fill: config('colors.c8-f1');
        }
      }
    }
  }
</style>
